import { service } from '../axios';
export function importInstrumentSnapshot(reportYear) {
    return service({
        url: '/sj1/importToSnapshot',
        method: 'post',
        data: { reportYear } // 这里会传递 reportYear
    });
}
export function generateAndSaveDiffRecords(reportYear, compareYear) {
    return service({
        url: '/sj1/generateAndSaveDiffRecords',
        method: 'post',
        data: { reportYear, compareYear }
    });
}
// 1. 总览
export function getOverview(data) {
    return service({
        url: '/diffRecord/overview',
        method: 'post',
        data
    });
}
// 2. 字段分析
export function getFieldAnalysis(data) {
    return service({
        url: '/diffRecord/fieldAnalysis',
        method: 'post',
        data
    });
}
// 3. 趋势分析
export function getDiffTrend(data) {
    return service({
        url: '/diffRecord/trend',
        method: 'post',
        data
    });
}
// 4. 维度统计
export function getDimensionStats(data) {
    return service({
        url: '/diffRecord/dimension',
        method: 'post',
        data
    });
}
// 5. 明细（支持分页）
export function getDiffDetail(data) {
    return service({
        url: '/diffRecord/detail',
        method: 'post',
        data
    });
}
export function getSJ1DiffDiffView(params) {
    return service({
        url: '/sj1/getSJ1DiffDiffView',
        method: 'get',
        params
    });
}
export function getStatCurrentAssets() {
    return service({
        url: '/sj1/getStatCurrentAssets',
        method: 'get'
    });
}
export function getSJ4StatCurrentExperimentProjects() {
    return service({
        url: '/sj4/getStatCurrentExperimentProjects',
        method: 'get'
    });
}
//sj4
export function importSJ4Snapshot(reportYear) {
    return service({
        url: '/sj4/importToSnapshot',
        method: 'post',
        data: { reportYear }
    });
}
export function generateAndSaveSJ4DiffRecords(reportYear, compareYear) {
    return service({
        url: '/sj4/generateAndSaveDiffRecords',
        method: 'post',
        data: { reportYear, compareYear }
    });
}
export function getSJ4DiffDiffView(params) {
    return service({
        url: '/sj4/getSJ4DiffDiffView',
        method: 'get',
        params
    });
}
//-----------------------------SJ6-----------------------------
export function importSJ6Snapshot(reportYear) {
    return service({
        url: '/sj6/importToSnapshot',
        method: 'post',
        data: { reportYear }
    });
}
export function getSJ6StatCurrentLabInfo() {
    return service({
        url: '/sj6/getStatCurrentLabInfo',
        method: 'get',
    });
}
export function generateAndSaveSJ6DiffRecords(reportYear, compareYear) {
    return service({
        url: '/sj6/generateAndSaveDiffRecords',
        method: 'post',
        data: { reportYear, compareYear }
    });
}
export function getSJ6DiffDiffView(params) {
    return service({
        url: '/sj6/getSJ6DiffDiffView',
        method: 'get',
        params
    });
}
//-----------------------------SJ5-----------------------------
export function importSJ5Snapshot(reportYear) {
    return service({
        url: '/sj5/importToSnapshot',
        method: 'post',
        data: { reportYear }
    });
}
export function getSJ5StatCurrentLabInfo() {
    return service({
        url: '/sj5/getStatCurrentLabInfo',
        method: 'get',
    });
}
export function generateAndSaveSJ5DiffRecords(reportYear, compareYear) {
    return service({
        url: '/sj5/generateAndSaveDiffRecords',
        method: 'post',
        data: { reportYear, compareYear }
    });
}
export function getSJ5DiffDiffView(params) {
    return service({
        url: '/sj5/getSJ5DiffDiffView',
        method: 'get',
        params
    });
}
export function getSJ2Summary(params) {
    return service({
        url: '/sj2/getSJ2Summary',
        method: 'get',
        params
    });
}
export function importLatestInstruments(reportYear) {
    return service({
        url: '/sj1/importLatestInstruments',
        method: 'post',
        data: { reportYear }
    });
}
export async function downloadSj(typeStr, fileName) {
    try {
        const response = await service({
            url: `/${typeStr}/${typeStr}/download`,
            method: 'get',
            responseType: 'blob',
        });
        const blob = new Blob([response], {
            type: 'text/plain;charset=gbk',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || `SJ1_${new Date().getTime()}.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
    catch (e) {
        console.error('SJ1下载失败', e);
    }
}
export function importSJ1ToSJ3() {
    return service({
        url: '/sj3/importSJ1ToSJ3',
        method: 'post',
    });
}
export function importSJ4FromLabCourses(year) {
    return service({
        url: '/sj4/importSJ4FromLabCourses',
        method: 'post',
        params: { year }
    });
}
export function importSJ5FromLabStaff(year) {
    return service({
        url: '/sj5/importSJ5FromLabStaff',
        method: 'post',
        params: { year }
    });
}
export function importSJ6FromLabBasic(year) {
    return service({
        url: '/sj6/importFromLabBasic',
        method: 'post',
        params: { year }
    });
}
export function getSJ1CountCheckErrorsByField() {
    return service({
        url: '/sj1/getSJ1CountCheckErrorsByField',
        method: 'get',
    });
}
export function getSJ4CountCheckErrorsByField() {
    return service({
        url: '/sj4/getSJ4CountCheckErrorsByField',
        method: 'get',
    });
}
export function getSJ5CountCheckErrorsByField() {
    return service({
        url: '/sj5/getSJ5CountCheckErrorsByField',
        method: 'get',
    });
}
export function getSJ6CountCheckErrorsByField() {
    return service({
        url: '/sj6/getSJ6CountCheckErrorsByField',
        method: 'get',
    });
}
export function execSJCheck() {
    return service({
        url: '/sjData/execSJCheck',
        method: 'post',
    });
}
export function getSJSummary() {
    return service({
        url: '/sjData/getSJSummary',
        method: 'post',
    });
}
